import React from "react";
import { TabelaDeCotacao } from "./index";

export default function LoteriasCotacoes({ tipoCotacoes, nomeJogo, type }) {
  return (
    <div class="container-cotacoes">
      <h1>Premiações!</h1>
      <h2>Quanto posso ganhar?</h2>
      <p>
        A premiação não é fixa. Os ganhos variam de acordo com a modalidade, a
        quantidade de prêmios escolhidos e o valor apostado. Cada modalidade tem
        uma cotação (valor pago para cada real apostado em um número e prêmio).
      </p>

      <TabelaDeCotacao
        nomeValor={tipoCotacoes.nomeValor}
        type={"loteria-popular"}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/components/cotacoes/loteria-popular.jsx